<template>
  <section class="home_section">
    <transition name="bounce">
      <div class="alert-custom-container">
        <span v-if="isCopy" class="alert alert-custom" >
          <span>{{ copy[lang()] }}</span>
        </span>
      </div>
    </transition>
    <div class="container">
      <div class="row home_container">
        <div class="col-md-6 main_img_media">
            <img src="../assets/LOGO.svg" title="logo" alt="logo" class="home_img">
        </div>
        <div class="home_infoblock col-md-6">

          <h3>{{ name[lang()] }}</h3>

          <div class="row ttt">
            <div class="col-md-12 contacts_left_block">
              <span style="font-size: 1.5rem;">+380991044900</span>
              <b-button
                class="btn services-custom-button home-email-button"
                @click="copiMail"
              >
                funbaseua@gmail.com
              </b-button>
              <span>
                <a href="https://www.instagram.com/funbase_ua" target="_blank">
                 <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="#fff" class="bi bi-instagram" viewBox="0 0 16 16">
                    <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334"/>
                  </svg>
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { store } from '../store.js'
export default {
    data () {
      return {
        isCopy: false
      }
    },
    methods: {
      lang() {
        return localStorage.getItem('lang');
      },
      copiMail() {
        window.navigator.clipboard.writeText('funbaseua@gmail.com')
          .then(() => {
            this.isCopy = true;
            setTimeout(() => this.isCopy = false, 1500);
          })
      },
    },
    created() {
      store.window.w = window.innerWidth;
    },
    computed: {
      width() {
        return store.window.w
      },
      name() {
        return store.homeName
      },
      copy() {
        return store.copyMail
      }
    }
}
</script>

<style>
  .home_container {
    display: flex;
    align-items: center;
    height: calc(100vh - 10vh);
  }
  .home_img {
    width: 100%;
    height: auto;
  }
  .home_infoblock > h3 {
    text-align: center;
    text-transform: uppercase;
  }
  .home_infoblock > p {
    text-align: center;
    max-width: 80%;
    margin-left: 10%;
    padding: 0;
    /*color: #fff;*/
  }
  @media (max-width: 767px) {
    .main_img_media {
      padding: 1rem;
    }
    .home_infoblock > p {
      max-width: unset;
      margin-left: unset;
    }
  }

  .home-email-button {
    margin-bottom: 16px;
  }

  .bounce-enter-active {
    animation: bounce-in .5s;
  }
  .bounce-leave-active {
    animation: bounce-in .5s reverse;
  }
  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1.5);
    }
    100% {
      transform: scale(1);
    }
  }
  .mail-btn {
    margin: 1rem;
  }
  .alert {
    text-align: center;
    position: absolute;
    width: 100%;
    top: 2rem;
  }
  .mail_spinner {
    float: right;
  }
  .contacts_left_block {
    text-align: center;
  }
  .contacts_left_block > span {
    display: block;
    margin-bottom: 1rem;
    color: #fff;
  }
  .contacts_left_block:last-child {
    max-width: 80%;
    margin-left: 10%;
  }
  .ttt {
    display: flex;
    align-items: center;
  }
  .prices_container  > h5 {
    text-align: center;
  }
  .alert-custom-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
  .alert-custom {
    background: linear-gradient(90deg, #511B75, #FF6B00);
    border: 1px solid #fff;
    width: 300px;
    color: #fff;
  }
  .mail_block {
    position: relative;
  }
  .mail_block > button{
    float: right;
  }
  .mail_block > input {
    margin-bottom: 1rem;
  }
  .mail_block > label {
    margin-bottom: 0.2rem !important;
  }
  .mail_block > textarea {
    margin-bottom: 1rem;
  }

  @media (max-width: 767px) {
    .mail_block {
      margin-bottom: 3rem;
    }
    .alert {
      position: absolute;
      z-index: 999;
      top: 15vh;
      left: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue